import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class QuestionsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getAllQuestions(router){
    const url = `/api/questions`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getQuestionById(id, router) {
    const url = `/api/questions/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createQuestion(params, router) {
    const url = `/api/questions`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateQuestion(id, params, router) {
    const url = `/api/questions/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteQuestion(id, router) {
    const url = `/api/questions/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getAllQuestionTypes(router){
    const url = `/api/questions/types`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getQuestionTypeById(id, router) {
    const url = `/api/questions/types/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createQuestionType(params, router) {
    const url = `/api/questions/types`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateQuestionType(id, params, router) {
    const url = `/api/questions/types/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteQuestionType(id, router) {
    const url = `/api/questions/types/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  getAllQuestionChoices(router){
    const url = `/api/questions/choices`
    return this.CommonAPIService.getCall(url, null, router)
  }

  getQuestionChoiceById(id, router) {
    const url = `/api/questions/choices/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  createQuestionChoice(params, router) {
    const url = `/api/questions/choices`;
    return this.CommonAPIService.postCall(url, params, router);
  }

  updateQuestionChoice(id, params, router) {
    const url = `/api/questions/choices/${id}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  deleteQuestionChoice(id, router) {
    const url = `/api/questions/choices/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

}
export default QuestionsAPIService;
